<template>
   <div class="registrationAdmin" >
     <div class="container">
        <el-row class="registrationSearch">
            <el-row :gutter="20"  class="line_infor searchInput">
                <el-col :span="4">
                    <el-input v-model='search.name' placeholder='患者姓名' ></el-input>
                </el-col>
                <el-col :span="4">
                    <el-input v-model='search.imageNum' placeholder='影像号' ></el-input>
                </el-col>
                <el-col :span="4">
                    <el-input v-model='search.registrationNum' placeholder='登记单号' ></el-input>
                </el-col>
                <el-col :span="4">
                  <el-input v-model='search.checkNum' placeholder='检查单号' ></el-input>
                </el-col>
                <el-col :span="6" >
                    <el-button type='primary' class="search_btn" icon="el-icon-search" size="mini" :loading="loading" @click="searchList">搜索</el-button>
                    <el-button type='success'  class="search_btn" icon="el-icon-circle-close-outline" size="mini" @click="empty" style="margin-left:20px;" :disabled="loading">清空</el-button>
                </el-col>
            </el-row>
            <el-collapse>
            <el-collapse-item class="">
                <template slot="title">
                </template>
                <div class="search_line">
                  <span class="search_name">设备类型</span>
                  <div class="search_group">
                      <el-radio-group v-model="searchBtn.checkType" @change="getRegistrationadminList">
                        <el-radio-button  :label='all.Text' :key="all.id">{{all.Text}}</el-radio-button>
                        <el-radio-button v-for='item in dict.checkType' :key='item.id' :label='item.name'>{{item.name}}</el-radio-button>
                      </el-radio-group>
                  </div>
                </div>
                <div class="search_line">
                  <span class="search_name">登记时间</span>
                  <div class="search_group">
                      <el-radio-group v-model="searchBtn.registrationTime" @change = "getTime(searchBtn.registrationTime)" >
                          <el-radio-button v-for='item in registrationTime_arr' :key='item.id' :label='item.Value'>{{item.Text}}</el-radio-button>
                          <el-radio-button label='4'  class="nav-time">
                              <el-date-picker  v-model="search.time"  type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                  value-format="yyyy-MM-dd" @change="changeTime">
                              </el-date-picker>
                          </el-radio-button>
                      </el-radio-group>
                  </div>
                </div>
                <div class="search_line">
                  <span class="search_name">医疗状态</span>
                  <div class="search_group">
                      <el-radio-group v-model="searchBtn.medicalState" @change="getRegistrationadminList" >
                        <el-radio-button  :label='all.Text' :key="all.id" >{{all.Text}} </el-radio-button>
                        <el-radio-button v-for='item in medicalState_arr' :key='item.id' :label='item.Value' ></el-radio-button>
                      </el-radio-group>
                  </div>
                </div>
            </el-collapse-item>
        </el-collapse>
        </el-row>
        <el-row class="registrationList">
            <el-table v-if='registerList.results' :data="registerList.results" key="registerList.results"   style="width: 100%" empty-text="暂无信息" stripe size='mini' v-loading="loading">
                <!-- <el-table-column  prop="deviceType"  label="设备类型" min-width='120px'>
                  <template slot-scope="scope">
                      <span class="bac_tip1 bac_tip">{{ scope.row.deviceType.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column  prop="bodyPartGroup"  label="检查部位" min-width='120px' :show-overflow-tooltip = "this.tooltip">
                  <template slot-scope="scope">
                      <span class="bac_tip2 bac_tip">{{ scope.row.bodyPartGroup.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column  prop="itemName"  label="检查项目"  min-width='120px'  :show-overflow-tooltip = "this.tooltip">
                  <template slot-scope="scope">
                      <span class="bac_tip3 bac_tip">{{ scope.row.itemName.name }}</span>
                  </template>
                </el-table-column> -->
                <el-table-column :fixed="index === 0" v-for='(col, index) in headerList' :show-overflow-tooltip = 'true' :key='index' :min-width="col.width" :prop='col.prop' :label='col.label' v-if='col.isShow'>
                  <template slot-scope="scope">
                    <!-- <el-popover trigger="hover" placement="top" v-if="col.prop === 'itemName'">
                      <div slot="reference" class="name-wrapper">
                        <span style="background: #ff9d60;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop].name}}</span>
                        <div v-else></div>
                      </div>
                    </el-popover> -->
                    <span v-if="col.prop === 'scanMode'">
                      {{scope.row[col.prop].name}}
                    </span>
                    <span v-else-if="col.prop === 'deviceName'">
                      {{scope.row[col.prop].name}}
                    </span>
                    <el-popover trigger="hover" placement="top" v-else-if="col.prop === 'itemName'">
                       {{scope.row[col.prop].name}}
                      <div slot="reference" class="name-wrapper">
                        <span style="background: #ff9d60;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop].name}}</span>
                        <div v-else></div>
                      </div>
                    </el-popover>
                    <el-popover trigger="hover" placement="top" v-else-if="col.prop === 'deviceType'">
                       {{scope.row[col.prop].name}}
                      <div slot="reference" class="name-wrapper">
                        <span style="background: #FF8C8C;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop].name}}</span>
                        <div v-else></div>
                      </div>
                    </el-popover>
                    <el-popover trigger="hover" placement="top" v-else-if="col.prop === 'bodyPartName'">
                      {{scope.row[col.prop]}}
                      <div slot="reference" class="name-wrapper">
                        <span style="background: #FF8C8C;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop]}}</span>
                        <div v-else></div>
                      </div>
                    </el-popover>
                    <span v-else>
                      {{scope.row[col.prop]}}
                    </span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="name" label="姓名" width='100px'>
                    <template slot-scope="scope">
                      <div>
                        {{scope.row.name}}
                        <span v-if='scope.row.emergency' style="width: 29px;position: absolute;left: 0;top: 0;display:inline-block;"><img style="width:100%;" src="../../assets/Emergency.png" alt=""></span>
                      </div>
                  </template>
                </el-table-column>
                <el-table-column prop="sex" label="性别" width='60px'></el-table-column>
                <el-table-column prop="patientAge" label="年龄" width='60px'></el-table-column>
                <el-table-column prop="status" label="状态" width='80px'></el-table-column>
                <el-table-column prop="deviceName" label="影像室" width='80px'>
                  <template slot-scope="scope">
                      <span >{{ scope.row.deviceName.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="patientNo" label="影像号"  width='120px'  :show-overflow-tooltip = "this.tooltip"  >
                </el-table-column>
                <el-table-column prop="regNo" label="登记单号"  width='120px'  :show-overflow-tooltip = "this.tooltip"  >
                </el-table-column>
                <el-table-column prop="performNo"  label="检查号" width='120px'  :show-overflow-tooltip = "this.tooltip"  >
                </el-table-column>

                <el-table-column  prop="register"  label="登记医生"  width="100px"></el-table-column>
                <el-table-column  prop="regDt"  label="登记时间" :show-overflow-tooltip = "this.tooltip">
                </el-table-column> -->
                <el-table-column  label="功能" fixed="right" class="control" width="200px" prop="status">
                    <template slot-scope="scope">
                        <span class="funBtn" v-if="scope.row.status==='待检查'?true:false">
                            <el-tooltip class="item" effect="dark" content="新增检查信息" placement="top" >
                              <el-button   type="text"  size="mini" @click="show_add(scope.row,true,tempData,form1,scope.$index)" >
                                  <svg-icon  icon-class='add'  class="svg5" ></svg-icon>
                              </el-button>
                            </el-tooltip>
                        </span>
                         <span class="funBtn"  v-if="scope.row.status==='待检查'?true:false">
                        <el-tooltip class="item" effect="dark" content="修改检查信息" placement="top">
                            <el-button  type="text"  size="mini" @click="show_add(scope.row,false,tempData,form1,scope.$index)">
                                <svg-icon  icon-class='修改检查信息'  class="svg4" ></svg-icon>
                            </el-button>
                        </el-tooltip>
                         </span>
                          <span class="funBtn" >
                        <el-tooltip class="item" effect="dark" content="患者详情" placement="top">
                            <el-button  type="text"  size="mini" @click="patient_detail(scope.row.regId)">
                              <svg-icon  icon-class='patientDetail-Round'  class="svg3" ></svg-icon>
                            </el-button>
                        </el-tooltip>
                         </span>
                          <span class="funBtn"  v-if="scope.row.status==='待检查'?true:false">
                        <el-tooltip class="item" effect="dark" content="患者登记修改" placement="top">
                            <el-button  type="text"  size="mini"  @click="editRegistration(scope.row)">
                                <svg-icon  icon-class='患者登记修改'  class="svg2" ></svg-icon>
                            </el-button>
                        </el-tooltip>
                         </span>
                          <span class="funBtn"  v-if="scope.row.status==='待检查'?true:false">
                        <el-tooltip class="item" effect="dark" content="删除" placement="top">
                            <el-button  type="text"  size="mini" @click="delInfor(scope.row)">
                                <svg-icon  icon-class='删除'  class="svg1" ></svg-icon>
                            </el-button>
                        </el-tooltip>
                         </span>
                    </template>
                </el-table-column>
            </el-table>
            <div v-else style="width:100%;height: calc(100vh - 330px);text-align:center;background:#f8f8f8;"
            v-loading = 'loading'>
              <img src="../../assets/empty_01.png" alt="" style="width: auto;height: calc(100vh - 357px);"  />
            </div>
        </el-row>
     </div>
     <el-row class="page"  v-if='registerList.results'>
        <div class="block">
          <el-pagination  @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="this.registerList.totalCount ">
          </el-pagination>
        </div>
    </el-row>
     <!-- 登记列表增改 -->
     <el-dialog :title="title" :visible.sync="dialog1" width="500px" custom-class='add_check' >
        <el-form :model="form1" :rules="rules1" ref="form1" :show-message="false">
          <span  class="red_color must1"><img src="~@/assets/star.png" alt=""></span>
          <el-form-item label="设备类型"  class="check_type" >
            <el-select v-model="form1.check" placeholder="" >
              <el-option v-for="item in checkType_arr" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
           <span  class="red_color must2"><img src="~@/assets/star.png" alt=""></span>
          <el-form-item label="检查部位" class="check_body">
            <el-select v-model="form1.checkBody" placeholder="" @change="changeBody(form1.checkBody)">
              <el-option v-for="item in checkList.checkBody" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <span  class="red_color must3"><img src="~@/assets/star.png" alt=""></span>
          <el-form-item label="检查项目" class="check_item" >
            <el-select v-model="form1.deviceType" placeholder="" >
              <el-option v-for="item in checkList.checkProject" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="扫描类型" class="scanty_type">
            <el-select v-model="form1.scanType" placeholder="">
               <el-option v-for="item in dict.scanningtType" :key="item.id" :label="item.dictName" :value="item.dictName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="影像室" class="image_room" v-if="show_image">
            <el-select v-model="form1.image_room" placeholder="">
              <el-option v-for="item in imageRoom" :key="item.id" :label="item.examRoom" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center;">
          <el-button type="primary" @click="add_check(form1)" v-if="!show_image" icon="el-icon-circle-plus-outline" size="medium">添加项目</el-button>
          <el-button type="primary" @click="change_check(form1)" icon="el-icon-edit" v-else>修改项目</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { formatDate } from '@/utils/index.js'
export default {
  name: 'registrationAdmin',
  data() {
    return {
      // hospId: '',
      registerLists: [],
      currentPage: 1, // 当前页
      pageSize: 10, // 条数
      title: '',
      show_image: false,
      form1: {
        check: '',
        checkBody: '',
        deviceType: '',
        scanType: '',
        image_room: '',
        index: '',
        modality: '',
        regId: '',
        performId: ''
      },
      rules1: {
        deviceType:
            [
              { required: true, message: '', trigger: 'change' }
            ]
      },
      checkType_arr: [],
      loading: false,
      tooltip1: 3,
      tooltip: true,
      search: {
        name: '',
        imageNum: '', // 影像号
        registrationNum: '',
        checkNum: '',
        time: [
          formatDate(new Date(), 'yyyy-MM-dd'),
          formatDate(new Date(), 'yyyy-MM-dd')
        ]
      },
      all: {
        id: 'absa46513241651',
        Text: '全部'
      },
      searchBtn: {
        checkType: '全部', // 设备类型
        registrationTime: '今天', // 登记时间
        medicalState: '全部' // 医疗状态
      },
      registrationTime_arr: [
        {
          id: 'absa465132416511234',
          Value: '今天',
          Text: '今天'
        }, {
          id: 'absa465132416513',
          Value: '最近3天',
          Text: '最近3天'
        }, {
          id: 'absa465132416514',
          Value: '最近7天',
          Text: '最近7天'
        }],
      medicalState_arr: [
        {
          id: 'absa46513241651123',
          Value: '已登记',
          Text: '已登记'
        }, {
          id: 'lksjkldjaskdj',
          Value: '待检查',
          Text: '待检查'
        }, {
          id: 'skdsakdsald',
          Value: '已检查',
          Text: '已检查'
        }, {
          id: 'kkjkjjhnnhsdj55',
          Value: '影像上传中',
          Text: '影像上传中'
        }, {
          id: 'lskdjskldjsaklndsad555',
          Value: '影像已上传',
          Text: '影像已上传'
        }, {
          id: 'lskdjskldjsaklndsad5550',
          Value: '诊断中',
          Text: '诊断中'
        }],
      dialog1: false,
      tempData: {
        check: '',
        checkBody: '',
        deviceType: '',
        scanType: '',
        image_room: '',
        index: '',
        modality: '',
        regId: '',
        performId: ''
      }
    }
  },
  computed: {
    ...mapGetters(['hospitals', 'name', 'userId', 'departId',
      'departments', 'dict', 'checkList', 'imageRoom', 'registerList',
      'currentUserRoleDepart', 'headerList'])
  },
  created() {
    this.getRegistrationadminList()
    this.GetTableHeaderConfigs()
  },
  methods: {
    changeTime() {
      this.searchBtn.registrationTime = '4'
      this.getRegistrationadminList()
    },
    getTime(value) {
      switch (value) {
        case '今天':
          this.search.time = [formatDate(new Date(), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
          break
        case '最近3天':
          this.search.time = [formatDate(new Date(new Date() - 3600 * 1000 * 24 * 3), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
          break
        case '最近7天':
          this.search.time = [formatDate(new Date(new Date() - 3600 * 1000 * 24 * 7), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
          break
      }
      this.getRegistrationadminList()
    },
    // 获取列表
    getRegistrationadminList() {
      this.loading = true
      this.$store.dispatch('getregisterList',
        {
          departId: this.departId,
          patientName: this.search.name,
          imageNo: this.search.imageNum, // 影像号
          regNo: this.search.registrationNum, // 登记单号
          performNo: this.search.checkNum, // 检查单号
          deviceType: this.searchBtn.checkType, // 设备类型
          regDate: {
            begin: this.search.time[0],
            end: this.search.time[1]
          },
          diagStatus: this.searchBtn.medicalState, // 医疗状态
          Paging: {
            pageIndex: this.currentPage,
            pageCount: this.pageSize
          }
        }
      ).then(() => { // 获取列表
        this.loading = false
      }).catch(() => {
        this.$message({ message: '获取列表失败，请重新操作', type: 'warning' })
        this.loading = false
      })
    },
    GetTableHeaderConfigs() {
      this.$store.dispatch('GetTableHeaderConfigs', { departId: this.currentUserRoleDepart.departId, type: 1 }).then(() => { //
      }).catch(() => {
        this.$message({ message: '获取表头配置失败，请重新获取', type: 'warning' })
      })
    },
    // 条数
    handleSizeChange(val) {
      this.pageSize = val
      this.getRegistrationadminList()
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val
      this.getRegistrationadminList()
    },
    // 搜索列表
    searchList() {
      this.getRegistrationadminList()
    },
    // 清空
    empty() {
      Object.keys(this.search).forEach(key => { this.search[key] = '' })
      this.search.time = [formatDate(new Date(), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
      this.searchBtn.checkType = '全部'
      this.searchBtn.registrationTime = '今天'
      this.searchBtn.medicalState = '全部'
      this.getRegistrationadminList()
    },
    changeBody(value) {
      this.form1.deviceType = ''
      this.getItemname(value)
    },
    // 获取检查部位
    getBody(value) {
      this.$store.dispatch('getcheckBody', { departId: this.departId, modality: this.form1.modality }).then(() => {
        this.getItemname(this.form1.checkBody)// 获取检查项目
      }).catch(() => {
        this.$message({ message: '获取检查部位失败，请重新获取', type: 'warning' })
      })
    },
    // 获取检查项目
    getItemname(value) {
      this.$store.dispatch('getcheckProject', { partGroupId: value }).then(() => {
      }).catch(() => {
        this.$message({ message: '获取检查项目失败，请重新获取', type: 'warning' })
      })
    },
    // 获取影像室
    getImageroom(value) {
      this.$store.dispatch('getimageRoom', { departId: this.departId, deviceType: this.form1.check }).then(() => {
        this.form1.image_room = value // 影像科室默认值
      }).catch(() => {
        this.$message({ message: '获取检查项目失败，请重新获取', type: 'warning' })
      })
    },
    // 增改功能
    show_add(data, falg, tempData, form1, index) {
      var a = []
      form1.regId = data.regId
      form1.performId = data.performId
      for (let index = 0; index < this.checkList.checkType.length; index++) {
        if (data.deviceType.key === this.checkList.checkType[index].id) {
          a = this.checkList.checkType[index]
          form1.check = data.deviceType.key // 设备类型默认值
          form1.modality = this.checkList.checkType[index].modality // 模态默认值
          // 获取影像室
          this.getImageroom(data.deviceName.key)
          // 获取检查部位
          this.$store.dispatch('getcheckBody', { departId: this.departId, modality: form1.modality }).then(() => {
            form1.checkBody = data.bodyPartGroup.key // 检查部位默认值
            form1.deviceType = data.itemName.key// 检查项目默认值
            form1.scanType = data.scanMode.name // 扫描类型默认值
            form1.index = index
            Object.keys(form1).forEach(function(key) { // 复制操作，用于校验比对
              tempData[key] = form1[key]
            })
            // 获取检查项目
            this.getItemname(data.bodyPartGroup.key)
            setTimeout(() => {
              this.dialog1 = true
            }, 500)
          }).catch(() => {
            this.$message({ message: '获取检查部位失败，请重新获取', type: 'warning' })
          })
          break
        }
      }
      this.checkType_arr = []
      this.checkType_arr.push(a)
      if (falg) {
        this.show_image = false
        this.title = '新增检查信息'
      } else {
        this.show_image = true
        this.title = '修改检查信息'
      }
    },
    // 添加检查信息
    add_check(data) {
      if (JSON.stringify(this.tempData) === JSON.stringify(this.form1)) { // 添加检查信息校验
        this.$message({ message: '不可以重复添加', type: 'warning' })
        return
      }
      if (data.deviceType === '') {
        this.$message({ message: '请将必填信息填写完整', type: 'warning' })
        return
      }
      var temp = {}
      temp.regId = data.regId
      temp.DeviceTypeId = data.check // 设备类型
      temp.performId = data.performId // 执行单号
      temp.deviceId = data.image_room // 影像科室
      temp.bodyPartId = data.checkBody // 检查部位
      temp.itemId = data.deviceType // 检查项目
      temp.scanMode = data.scanType // 扫描类型
      temp.olditemId = this.tempData.deviceType
      this.$store.dispatch('appendProcedure', temp).then((data) => {
        this.getRegistrationadminList()
        this.$message({ message: '添加成功', type: 'success' })
        this.dialog1 = false
      }).catch(() => {
      })
    },
    // 修改检查信息
    change_check(data) {
      if (JSON.stringify(this.tempData) === JSON.stringify(this.form1)) { // 修改检查信息校验
        this.$message({ message: '检查信息未修改', type: 'warning' })
        return
      }
      if (data.deviceType === '') {
        this.$message({ message: '请将必填信息填写完整', type: 'warning' })
        return
      }
      var temp = {}
      temp.regId = data.regId
      temp.performId = data.performId // 执行单号
      temp.deviceId = data.image_room // 影像科室
      temp.bodyPartId = data.checkBody // 检查部位
      temp.itemId = data.deviceType // 检查项目
      temp.scanMode = data.scanType // 扫描类型
      temp.olditemId = this.tempData.deviceType
      this.$store.dispatch('updateProcedure', temp).then((data) => {
        this.getRegistrationadminList()
        this.$message({ message: '修改成功', type: 'success' })
        this.dialog1 = false
      }).catch(() => {
      })
    },
    delInfor(data) {
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        var temp = {}
        temp.regId = data.regId
        temp.performId = data.performId
        temp.deviceId = data.deviceName.key
        temp.bodyPartId = data.bodyPartGroup.key
        temp.itemId = data.itemName.key
        temp.scanMode = data.scanMode.name
        this.$store.dispatch('deleteProcedure', temp).then(() => {
          this.getRegistrationadminList()
          this.$message({ message: '删除成功', type: 'success' })
        }).catch(() => {
          this.$message({ message: '删除失败，请重新删除', type: 'warning' })
        })
      }).catch(() => {
      })
    },
    patient_detail(data) {
      var temp = window.location.href.split('#')[0]
      window.open(temp + '#/registration/patient?regId=' + data, '_blank')
    },
    editRegistration(data) {
      this.$router.push({ path: '/editRegistration', name: 'EditRegistration', query: { regId: data.regId }})
    }
  },
  filters: {
    checkingItems(datas) {
      if (datas.length > 11) {
        datas = datas.slice(0, 10) + '…'
      }
      return datas
    }
  }
}
</script>
<style rel='stylesheet/scss' lang='scss' scoped>
  .name-wrapper{
    height: 23px;
      span{
        background: #FF9D60;
        color:#fff;
        padding: 4px 5px;
        border-radius: 3px;
        // width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
</style>



